export default {
    languages: ["pt", "en", "fr"]
}
